import { baseMutations, baseState } from '@/store/mixins'
import MainProgram from '@/api/main-program'
import SubProgram from '@/api/sub-program'
import level from '@/api/level'
import grade from '@/api/grade'
import httpClient from '@/http-client'
const BASE_URL = '/api/v2/payment/fee-predefine-items'

export default {
	namespaced: true,
	state: {
		...baseState
	},
	mutations: {
		...baseMutations
	},
	actions: {
		async fetch(context, attrubutes = {}) {
			let params = Object.assign(
				{
					page: context.state.pagination.page,
					perPage: context.state.pagination.perPage,
					search: context.state.search

				},
				attrubutes
			)
			let response = await httpClient.get(`${BASE_URL}/fecth`, {
				params
			})
			context.commit('RECEIVE_RESOURCES', response.data)
			return response
		},
		getMainProgram(context, attributes = {}) {
			return MainProgram.get({
				params: {
					fields: {
						academic_program_mains: 'acp_id,acp_name_foreign'
					},
					page: -1
				},
				headers: {
					'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
				}
			})
		},
		getGrade(context, acp_id) {
			return grade.get({
				params: {
					fields: {
						academic_program_level_grades: 'grade_id,grade_name_foreign'
					},
					'filter[by_main_program]': acp_id,
					page: -1
				},
				header: {
					'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
				}
			})
		},

		formViewModel(context, params = {}) {
			return httpClient.get(`${BASE_URL}/form-view-models`, { params })
		},

		onSave(context, data) {
			return httpClient.post(`${BASE_URL}`, data)
		},
		onUpdate(context, data) {
			return httpClient.put(`${BASE_URL}/${data.id}`, data)
		},
		onDelete(context, id) {
			return httpClient.delete(`${BASE_URL}/${id}`)
		}
	}
}